import { createAction, props } from '@ngrx/store';

export const LoadModules = createAction('[Dashboard] Load Modules', props<{ payload: any}>())
export const LoadModulesSuccess = createAction('[Dashboard] Load Modules Success', props<{ payload: any}>())
export const LoadModulesFail = createAction('[Dashboard] Load Modules Fail', props<{ payload: any}>())

